import React, { Component } from 'react';
import { 
  Col, 
  Button,
  Label,
  Input,
  Form,
  FormGroup
} from 'reactstrap';
export default class AdminAddFood extends Component {

  addFood = (e) => {
    e.preventDefault();
    alert("Demo mode: food item not actually added.");
  }

  render() {
    return (
      <div>
        <Form onSubmit={this.addFood}>
        <h1>Add food item</h1>
          <FormGroup row>
            <Label sm={1}>Name</Label>
            <Col md={4}>
              <Input required autoComplete="off" name="name" type="text" placeholder="Bacon" />
            </Col>
          </FormGroup>
          <FormGroup row>
            <Label sm={1}>Type</Label>
            <Col md={4}>
            <Input type="select" name="type">
              <option value="meat">Meat</option>
              <option value="rice">Rice</option>
              <option value="veg">Veg</option>
              <option value="side">Side</option>
              <option value="special">Special</option>
            </Input>
            </Col>
          </FormGroup >
          <FormGroup row>
            <Label sm={1}>Cost</Label>
            <Col md={2}>
              <Input autoComplete="off" name="costLg" type="text" placeholder="Large" />
            </Col>
            <Col md={2}>
              <Input autoComplete="off" name="costSm" type="text" placeholder="Small" />
            </Col>
          </FormGroup >
          <Button size="sm" color="primary">Add</Button>
        </Form>
      </div>
    )
  }
}
